export default __webpack_public_path__ + "static/media/ViewDetails.09cc8ebb.svg";